import Vue from 'vue'
import VuePikaday from '@netcz/vue-pikaday'
import BootstrapVue from 'bootstrap-vue'
import SweetModal from 'sweet-modal-vue/src/plugin.js'
import VeeValidate, {Validator} from "vee-validate"
import pt_BR from 'vee-validate/dist/locale/pt_BR.js'
import Notifications from 'vue-notification'
import * as am4core from "@amcharts/amcharts4/core"
import am4themes_animated from "@amcharts/amcharts4/themes/animated"
import VueMq from 'vue-mq'
import "@netcz/vue-pikaday/dist/vue-pikaday.min.css"
import Icon from "@/app/components/Icon.vue"
import Loading from '@/app/components/Loading.vue'

import App from './App.vue'
import router from './router'

Vue.config.productionTip = false

// Registrar am4charts
am4core.addLicense("CH217405995");
am4core.useTheme(am4themes_animated);
// am4core.options.queue = true;
// am4core.options.onlyShowOnViewport = true;
am4core.options.minPolylineStep = 10;

Vue.use(VuePikaday);
Vue.use(BootstrapVue);
Vue.use(SweetModal);
Vue.use(VeeValidate, { fieldsBagName: 'veeValidateFields' });
Vue.use(Notifications);
// Vue.use(Vuebar);

// Install and Activate the Portuguese locale.
VeeValidate.Validator.localize('pt_BR', pt_BR);
Validator.extend("requiredRadio", {
    getMessage: `Este campo é obrigatório.`,
    validate: (value) => {
        return value > 0
    }
});

Vue.component('icon', Icon)
Vue.component('Loading', Loading)

Vue.use(VueMq, {
  breakpoints: {
    mobile: 450,
    tablet: 900,
    laptop: 1250,
    desktop: Infinity,
  }
})

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')

// Gerenciador de erros genéricos global
Vue.config.errorHandler = function (err, vm, info) {
  if (vm == null || !vm._isVue) {
      router.push({ name: "Erro", params: { mensagem: err }});
  } else {
      console.log("Erro identificado:", err);
      // console.log("vm:", vm);
      console.log("info:", info);
  }
}

// Font Awesome
import '@fortawesome/fontawesome-free/css/brands.css';
import '@fortawesome/fontawesome-free/css/regular.css';
import '@fortawesome/fontawesome-free/css/solid.css';
import '@fortawesome/fontawesome-free/css/fontawesome.css';